import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * SCRUM-1032 QC, 30 Oct — the ET reference "valid to" date moved 8 h later
 * on every save from Singapore.
 *
 * The API takes this shape, with no offset, and reads it as UTC. The client
 * formatted it in local time, so each save added the browser's UTC offset:
 * 08:13Z → 16:13Z → 00:13Z the next day. Both directions now go through UTC.
 */
export const ET_VALID_TO_FORMAT = 'MM-DD-YYYY hh:mm:ss A'

/**
 * The value for the payload.
 * - A string from the server goes back with the same UTC time.
 *   This holds with or without a trailing Z.
 * - A Date from the picker is an instant, sent as its UTC time.
 * - With no value, now.
 */
export const etValidToPayload = (value?: string | Date | null): string => {
  if (value instanceof Date) {
    return dayjs(value).isValid()
      ? dayjs(value).utc().format(ET_VALID_TO_FORMAT)
      : dayjs.utc().format(ET_VALID_TO_FORMAT)
  }
  if (value && dayjs.utc(value).isValid()) {
    return dayjs.utc(value).format(ET_VALID_TO_FORMAT)
  }
  return dayjs.utc().format(ET_VALID_TO_FORMAT)
}

/** The server's value as an instant for the picker, read as UTC. */
export const etValidToFromServer = (value?: string | null): Date =>
  value && dayjs.utc(value).isValid() ? dayjs.utc(value).toDate() : new Date()
